module.exports = __webpack_public_path__ + "media/22.41627a18.mp3";